export const IMPACT_CALCULATION_TITLE = 'Como calculamos seu impacto?';
export const IMPACT_CALCULATION_INTRO = 'Este número é uma estimativa de referência.';
export const IMPACT_CALCULATION_FORMULA = 'Pessoas alcançadas diretamente × 3 = impacto estimado';
export const IMPACT_CALCULATION_STEPS = [
  'Pessoas únicas alcançadas diretamente ao longo da sua jornada com a Eduzz, considerando os dados disponíveis nas bases que fazem parte do cálculo.',
  'Duplicidades evitadas sempre que possível.',
  'Multiplicamos esse alcance por três, utilizando como referência a média de aproximadamente três pessoas por domicílio no Brasil.'
] as const;
export const IMPACT_CALCULATION_DISCLAIMER =
  'O resultado representa uma estimativa de até onde o que você construiu pode ter reverberado, e não uma contagem individual de todas as pessoas impactadas.';

export const IMPACT_DIPLOMA_TITLE = 'Seu diploma de Criador (a) de Impacto';
export const IMPACT_DIPLOMA_PREVIEW_HEADING = 'Diploma de Criador (a) de Impacto';
export const IMPACT_DIPLOMA_NAME_HINT = 'O nome é só para exibição. O número de impacto não pode ser editado.';
export const IMPACT_DIPLOMA_POPUP_BLOCKED = 'Permita pop-ups para abrir o diploma em uma nova aba.';
export const IMPACT_DIPLOMA_EMPTY_NAME = 'Informe o nome que deve aparecer no diploma.';
export const IMPACT_DIPLOMA_DOWNLOAD_ERROR = 'Não foi possível gerar o diploma. Tente novamente.';
export const IMPACT_DIPLOMA_INVALID_URL = 'O endereço do diploma retornado é inválido.';
export const IMPACT_DIPLOMA_NAME_MAX_LENGTH = 50;
